import { DateTime } from 'luxon';
import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import CheckBox from 'components/atoms/CheckBox';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import Input from 'components/atoms/Input';
import { PortType, RootState } from 'types';
import { ActionsType, SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { translate } from 'utils/translate';

import cloneDateTime from 'utils/cloneDateTime';
import { clone, setKey } from 'utils/formHandlers';
import { DateRangePicker } from './../../../react-dates';

interface DateSelectModelProps {
    children?: string | JSX.Element | JSX.Element[];
    language: string;
    id?: string;
    data: any;
    actions: ActionsType | undefined;
    port: PortType;
    dateTimeFormat: DateTimeFormat;
    system: SystemType;
}

interface DateSelectModelState {
    endRange: DateTimeFormat;
    today: DateTimeFormat;
    startRange: DateTimeFormat;
    startDate: DateTimeFormat | null;
    endDate: DateTimeFormat | null;
    sourceStartDate: DateTimeFormat;
    sourceEndDate: DateTimeFormat;
    focusedInput: string;
    dateRange: string;
    lastDays: number | '';
    init: boolean;
}

class DateSelectModel extends Component<DateSelectModelProps, DateSelectModelState> {
    constructor(props: DateSelectModelProps) {
        super(props);
        this.state = {
            init: props.data.startDate && props.data.endDate ? false : true,
            focusedInput: props.data.foucus || 'startDate',
            dateRange: props.data.dateRange,
            lastDays: props.data.dateRange === 'lastDays' ? props.data.lastDays : '',

            // only to set the date range nothing else
            startRange: props.data.startRange,
            endRange: props.data.endRange,
            today: props.data.today,

            // if user not select date the deff is today start and end date
            startDate: props.data.startDate ? props.data.startDate.clone() : null,
            endDate: props.data.endDate ? props.data.endDate.clone() : null,

            // if user not select date the deff is today start and end date
            sourceStartDate: props.data.startDate
                ? props.data.startDate.clone()
                : props.dateTimeFormat.parseDateTime().startOf('day'),
            sourceEndDate: props.data.endDate ? props.data.endDate.clone() : props.dateTimeFormat.parseDateTime(),
        };
    }

    componentDidMount(): void {
        console.log(this.props.system.date.today.toString());
    }

    handleFormSave = () => {
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.setState(
            {
                startDate: this.state.sourceStartDate.clone().formatLocalDateToUTC(),
                endDate: this.state.sourceEndDate.clone().formatLocalDateToUTC(),
            },
            () => {
                this.applayDate(this.props.data.filterObject.date.end_utc.op === null);
                this.props.actions?.onCancel();
            }
        );
    };

    handleFormClear = () => {
        this.setState(
            {
                startDate: null,
                endDate: null,
            },
            () => {
                this.setState({
                    lastDays: '',
                    dateRange: '',
                });
                this.applayDate(true);
            }
        );
    };

    setFocusedInput = (input) => {
        if (input != null) {
            this.setState({ focusedInput: input });
        } else {
            this.setState({ focusedInput: 'startDate' });
        }
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
    };

    applayDate = (clear = false) => {
        const filterObject = clone(this.props.data.filterObject);
        setKey(
            filterObject,
            'date.end_utc.op',
            clear
                ? this.props.data.type === 'highlight'
                    ? this.state.sourceEndDate.clone()
                    : null
                : this.state.endDate?.clone()
        );
        setKey(
            filterObject,
            'date.start_utc.op',
            clear
                ? this.props.data.type === 'highlight'
                    ? this.state.sourceStartDate.clone()
                    : null
                : this.state.startDate?.clone()
        );
        setKey(filterObject, 'date.lastDays', clear ? '' : this.state.lastDays);
        setKey(filterObject, 'date.dateRange', clear ? '' : this.state.dateRange);

        this.props.actions?.setFilterObject(filterObject);
    };

    chanageDateRange = (dateRange: string, value: boolean) => {
        const { startDate, endDate } = this.props.system.date.today.getDateFromDays(
            dateRange,
            dateRange === 'lastDays' ? this.state.lastDays || 1 : 0,
            this.props.system.date.today
        );
        this.setState(
            {
                lastDays: dateRange === 'lastDays' ? this.state.lastDays || 1 : '',
                //@ts-ignore
                startDate: startDate,
                //@ts-ignore
                endDate: endDate,
                dateRange: dateRange,
                init: false,
            },

            this.applayDate
        );
    };

    changeDays = (name: string, value: any) => {
        this.setState(
            {
                dateRange: value !== '' ? 'lastDays' : '',
                lastDays: value,
                startDate: null,
                endDate: null,
            },

            () => {
                if (value === '') {
                    this.applayDate(true);
                    return;
                }
                this.chanageDateRange('lastDays', true);
            }
        );
    };

    isFutureTime = (date: DateTimeFormat) => {
        if (date.toTimestamp() > this.props.system.date.today.toTimestamp()) {
            return this.props.dateTimeFormat
                .now()
                .setHoursAndMinutes(
                    this.applyLocalOffset(this.state.sourceEndDate?.date).hour,
                    this.applyLocalOffset(this.state.sourceEndDate?.date).minute,
                    true
                );
        }
        return date;
    };


    setEnd = (date) => {
        console.log('event : set end date ', date.toFormat('dd/MM/yyyy'), this.state.startDate?.isSame(date));

        this.setState(
            {
                init: false,
                dateRange: '',
                lastDays: '',
                focusedInput: this.state.startDate?.isSame(date) ? 'endDate' : 'startDate',
                endDate: this.state.endDate
                    ? this.isFutureTime(
                          this.props.dateTimeFormat
                              .fromLuxon(this.convertToUTCKeepTime(date))
                              .setHoursAndMinutes(
                                  this.applyLocalOffset(this.state.endDate?.date).hour,
                                  this.applyLocalOffset(this.state.endDate?.date).minute,
                                  true
                              )
                      )
                    : this.isFutureTime(this.props.dateTimeFormat.fromLuxon(date).setHoursAndMinutes(23, 59, true)),
            },
            this.applayDate
        );
    };

    setStart = (date) => {
        this.setState(
            {
                focusedInput: this.state.endDate?.isSame(date) ? 'startDate' : 'endDate',
                init: false,
                dateRange: '',
                lastDays: '',
                startDate: this.state.startDate
                    ? this.props.dateTimeFormat
                          .fromLuxon(this.convertToUTCKeepTime(date))
                          .setHoursAndMinutes(
                              this.applyLocalOffset(this.state.startDate?.date).hour,
                              this.applyLocalOffset(this.state.startDate?.date).minute,
                              true
                          )
                    : this.props.dateTimeFormat.fromLuxon(date).setHoursAndMinutes(0, 0, true),
            },
            this.applayDate
        );
    };

    renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
        const currentMonth = month.month; // Luxon uses `.month` (1–12)
        const currentYear = month.year;

        const startYear = this.state.startRange.date.year;
        const endYear = this.state.endRange.date.year;

        const years: number[] = [];
        for (let y = endYear; y >= startYear; y--) {
            years.push(y);
        }

        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div>
                    <select
                        value={currentMonth - 1} // Convert to 0-indexed for select
                        onChange={
                            (e) => onMonthSelect(month, parseInt(e.target.value, 10) + 1) // Add 1 back for Luxon
                        }
                    >
                        {Array.from({ length: 12 }, (_, i) => (
                            <option key={i} value={i}>
                                {DateTime.local()
                                    .set({ month: i + 1 })
                                    .toFormat('LLLL')}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <select value={currentYear} onChange={(e) => onYearSelect(month, parseInt(e.target.value, 10))}>
                        {years.map((x, i) => {
                            const year = DateTime.now().year - i;
                            return (
                                <option key={year} value={year}>
                                    {x}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        );
    };

    convertToUTCKeepTime = (dt: DateTime): DateTime => {
        return dt.setZone('UTC', { keepLocalTime: true }).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    };

    applyLocalOffset = (utcDate: DateTime, op: 'plus' | 'minus' = 'plus'): DateTime => {
        const originZone = this.props.port.time;

        // Get the offset of the origin zone at the exact utcDate
        const offset = cloneDateTime(utcDate).setZone(originZone).offset;

        // Apply the offset based on the operation
        return op === 'plus' ? utcDate.plus({ minutes: offset }) : utcDate.minus({ minutes: offset });
    };

    render() {
        return (
            <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full   rounded ">
                <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                    <div className="text-lg leading-6 font-bold">{translate('Select date range')} </div>
                    <div onTouchEnd={this.handleFormCancel} onClick={this.handleFormCancel} className="cursor-pointer">
                        <Icon>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M18 6l-12 12" />
                            <path d="M6 6l12 12" />
                        </Icon>
                    </div>
                </div>
                <div className="flex gap-4 content-stretch">
                    <div className="flex w-calander h-calander">
                        <DateRangePicker
                            navPrev={null}
                            navNext={null}
                            onPrevMonthClick={() => {
                                return null;
                            }}
                            onNextMonthClick={() => {
                                return null;
                            }}
                            onClose={() => {
                                return null;
                            }}
                            hideKeyboardShortcutsPanel
                            displayFormat={() => 'dd/MM/yyyy'}
                            isOutsideRange={(date) => {
                                let endDate;

                                const diffMs = this.state.today.toTimestamp() - this.state.endRange.toTimestamp();

                                const oneDayMs = 24 * 60 * 60 * 1000;
                                if (Math.abs(diffMs) <= oneDayMs) {
                                    endDate = this.state.today.clone().endOf('day').date;
                                } else {
                                    endDate = this.state.endRange.date;
                                }

                                const convertUtcToPort = (dt) => {
                                    const dfWithZone = dt.setZone(this.props.port.time);
                                    return dfWithZone.setZone('UTC');
                                };

                                return !this.props.dateTimeFormat
                                    .fromLuxon(this.applyLocalOffset(date, 'minus'))
                                    .isBetween(this.state.startRange.date, convertUtcToPort(endDate));
                            }}
                            focused={this.state.focusedInput}
                            onFocusChange={(a) => {
                                this.setState({ focusedInput: a || 'startDate' });
                            }}
                            renderMonthElement={(data) => {
                                return this.renderMonthElement(data);
                            }}
                            focusedInput={this.state.focusedInput}
                            showClearDate={() => false}
                            keepOpenOnDateSelect={() => true}
                            startDate={
                                this.state.startDate?.date ? this.applyLocalOffset(this.state.startDate?.date) : null
                            }
                            endDate={this.state.endDate?.date ? this.applyLocalOffset(this.state.endDate?.date) : null}
                            verticalSpacing={0}
                            noBorder={true}
                            startDateId="startDate"
                            initialVisibleMonth={() => {
                                return this.state.startDate === null
                                    ? this.state.endDate === null
                                        ? this.state.endRange.clone().minus({ days: 27 }).date
                                        : this.state.endDate.clone().date
                                    : this.state.startDate.clone().minus({ days: 27 }).date;
                            }}
                            minimumNights={0}
                            endDateId="endDate"
                            onDatesChange={({ startDate, endDate }) => {
                                console.log('onDatesChange');
                                let date = this.state.focusedInput === 'endDate' ? endDate : startDate;
                                if (!date) {
                                    date = startDate;
                                }
                                const presetStartDate = this.state.startDate ? this.state.startDate.date : null;
                                const presetEndDate = this.state.endDate ? this.state.endDate.date : null;

                                if (startDate && presetEndDate && presetStartDate && !this.state.init) {
                                    let closeToEnd = 0;
                                    let closeToStart = 0;

                                    closeToStart = presetStartDate.diff(date, 'days').days;
                                    closeToEnd = presetEndDate?.diff(date, 'days').days;

                                    const absCloseToStart = Math.abs(closeToStart);
                                    const absCloseToEnd = Math.abs(closeToEnd);

                                    if (absCloseToStart < absCloseToEnd) {
                                        // closer to start
                                        this.setStart(date);
                                    } else if (absCloseToEnd < absCloseToStart) {
                                        // closer to end
                                        this.setEnd(date);
                                    }
                                } else {
                                    if (startDate) {
                                        if (presetEndDate) {
                                            const diffFromNow = startDate.diff(presetEndDate, 'days').days; // same logic style

                                            if (
                                                this.state.focusedInput === 'startDate' &&
                                                !presetStartDate &&
                                                diffFromNow > 0 // startDate is in the future
                                            ) {
                                                this.setStart(presetEndDate);
                                                this.setEnd(startDate);
                                                return;
                                            }
                                        }

                                        // DEFAULT
                                        this.setStart(startDate);
                                    }
                                    if (endDate) {
                                        this.setEnd(endDate);
                                    } else if (this.state.focusedInput === 'endDate' && startDate) {
                                        this.setEnd(startDate);
                                    } else if (
                                        presetEndDate &&
                                        startDate &&
                                        startDate.diff(presetEndDate, 'seconds').days >= 1
                                    ) {
                                        this.setEnd(startDate);
                                    }
                                }
                            }}
                            autoFocus
                        />

                        {/* <DateRange
                            onChange={(item) => {
                                this.onDatesChange(item['range1'].startDate, item['range1'].endDate);
                            }}
                            showSelectionPreview={true}
                            showDateDisplay={false}
                            moveRangeOnFirstSelection={false}
                            months={2}
                            rangeColors={[SYSTEM_COLOR, '#3ecf8e', '#fed14c']}
                            color={SYSTEM_COLOR}
                            ranges={this.state.ranges}
                            direction="horizontal"
                            preventSnapRefocus={true}
                            minDate={this.state.startRange.toJSDate()} // Set the minimum selectable date (10 days ago)
                            maxDate={this.state.endRange.toJSDate()} // Set the maximum selectable date (30 days from today)
                            calendarFocus="backwards"
                        /> */}
                    </div>
                    <div className="flex flex-col gap-x-2 gap-2 mt-6">
                        <div className="flex h-5 items-center gap-2">
                            <div className="flex items-center gap-2   ">
                                <CheckBox
                                    onChange={this.chanageDateRange}
                                    name="lastDays"
                                    value={this.state.dateRange === 'lastDays'}
                                ></CheckBox>
                                <div>{translate('last days')}</div>
                            </div>
                            <div className="ml-auto  mx-2 ">
                                <Input
                                    onChange={(name, value) => {
                                        if (value === '') {
                                            //@ts-ignore
                                            this.changeDays('lastDays', '');
                                            return;
                                        }

                                        const num = Number(value);

                                        if (!isNaN(num) && num > 0) {
                                            this.changeDays('lastDays', num);
                                        }
                                    }}
                                    value={this.state.lastDays}
                                    name="lastDays"
                                    className="h-4  w-16 mx-2 "
                                />
                            </div>
                        </div>
                        <div className="flex items-center gap-2  ">
                            <CheckBox
                                onChange={this.chanageDateRange}
                                name="today"
                                value={this.state.dateRange === 'today'}
                            ></CheckBox>
                            <div>{translate('Today')}</div>
                        </div>
                        <div className="flex items-center gap-2 ">
                            <CheckBox
                                onChange={this.chanageDateRange}
                                name="yesterday"
                                value={this.state.dateRange === 'yesterday'}
                            ></CheckBox>
                            <div>{translate('Yesterday')}</div>
                        </div>
                        <div className="flex items-center gap-2 ">
                            <CheckBox
                                onChange={this.chanageDateRange}
                                name="thisWeek"
                                value={this.state.dateRange === 'thisWeek'}
                            ></CheckBox>
                            <div>{translate('This week')}</div>
                        </div>
                        <div className="flex items-center gap-2 ">
                            <CheckBox
                                onChange={this.chanageDateRange}
                                name="lastWeek"
                                value={this.state.dateRange === 'lastWeek'}
                            ></CheckBox>
                            <div>{translate('last week')}</div>
                        </div>
                        <div className="flex items-center gap-2 ">
                            <CheckBox
                                onChange={this.chanageDateRange}
                                name="thisMonth"
                                value={this.state.dateRange === 'thisMonth'}
                            ></CheckBox>
                            <div>{translate('This month')}</div>
                        </div>
                        <div className="flex items-center gap-2 ">
                            <CheckBox
                                onChange={this.chanageDateRange}
                                name="lastMonth"
                                value={this.state.dateRange === 'lastMonth'}
                            ></CheckBox>
                            <div>{translate('last month')}</div>
                        </div>
                        <div className="flex items-center gap-2 ">
                            <CheckBox
                                onChange={this.chanageDateRange}
                                name="thisYear"
                                value={this.state.dateRange === 'thisYear'}
                            ></CheckBox>
                            <div>{translate('This year')}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end">
                    <div className="mt-2 flex gap-3">
                        <Button onClick={this.handleFormCancel} className="px-4 py-2 font-bold border border-gray-400">
                            {translate('Cancel')}
                        </Button>
                        <Button
                            onClick={this.handleFormClear}
                            className="px-4 py-2 bg-primary-clear rounded-md text-white"
                        >
                            {translate('Clear')}
                        </Button>
                        <Button
                            type="submit"
                            onClick={this.handleFormSave}
                            className="px-4 py-2 bg-primary-submit rounded-md text-white"
                        >
                            {translate('Save')}
                        </Button>
                    </div>
                </div>
            </Form>
        );
    }
}

const dateSelectModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    port: state.port.port,
    dateTimeFormat: state.port.dateTimeFormat,
    system: state.port.system,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dateSelectModelDispatchToProps = () => ({});

export default connect(dateSelectModelStateToProps, dateSelectModelDispatchToProps)(DateSelectModel);
